import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'animate.css'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import './assets/css/common.scss'
import locale from 'element-ui/lib/locale/lang/zh-CN'
import 'lib-flexible'

// 导入动画指令
import animateSlideInUp from './directives/animateSlideInUp';
import animateZoomIn from './directives/animateZoomIn';
import animateSlideInLeft from './directives/animateSlideInLeft';
import animateSlideInRight from './directives/animateSlideInRight';

// 注册指令
Vue.directive('animate-zoom-in', animateZoomIn);
Vue.directive('animate-slide-in-up', animateSlideInUp);
Vue.directive('animate-slide-in-left', animateSlideInLeft);
Vue.directive('animate-slide-in-right', animateSlideInRight);



Vue.use(ElementUI, { locale })
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
